// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"255":"7331010c48b9c46c","4075":"e1b995e3aa717cfb","8233":"963d33fd6066f01b"}[chunkId] + ".js";
};